export default class EventPageCtrl {
    constructor($scope, $stateParams, $q, $state, $timeout, $filter, $translate, SweetAlert, SideMenu, Event, Events, SlugService) {
        SideMenu.setActive('event');

        this._stateParams = $stateParams;
        this._translator = $filter('translate');
        this._state = $state;
        this._timeout = $timeout;
        this._scope = $scope;
        this._q = $q;

        this.alerter = SweetAlert;
        this.eventRepo = Event;
        this.eventHandler = Events;
        this.slugService = SlugService;

        this.loading = true;
        this.dragActive = false;
        this.type = this._stateParams.type;
        this.imageBankVisible = false;
        this.showScheduler = false;
        this.previousVisibilityValue = true;
        this.readOnly = ['time', 'place'];

        this.page = {
            open: true,
            publish_at: moment(),
            type: this._stateParams.type,
            visible: true,
            closed: false // Closed for new subscriptions
        };

        this.pageTypeNameToIdMap = {
            episubscription: 1,
            episurvey: 2
        };

        this.statusIdToNameMap = {
            1: 'draft',
            2: 'current',
            3: 'completed',
            4: 'scheduled',
            5: 'cancelled'
        };

        // Use service to avoid attempted translations before translation files are loaded.
        $translate([
            'EVENT:PAGE:FIRST_NAME', 'EVENT:PAGE:LAST_NAME', 'GLOBAL:EMAIL', 'EVENT:PAGE:COMPANY_LABEL',
            'GLOBAL:PHONE_NUMBER', 'EVENT:PAGE:TITLE_LABEL', 'EVENT:PAGE:CONSENT_LABEL', 'EVENT:PAGE:SURVEY_SCORE', 'EVENT:PAGE:COMMENTS',
            'GLOBAL:YES', 'GLOBAL:NO'
        ]).then((translations) => {
            this.episubscription = {
                forms: [
                    {label: translations['EVENT:PAGE:FIRST_NAME'], type: 'text', required: true, name: 'f_name'},
                    {label: translations['EVENT:PAGE:LAST_NAME'], type: 'text', required: true, name: 'l_name'},
                    {label: translations['GLOBAL:EMAIL'], type: 'email', required: true, name: 'email'},
                    {label: translations['EVENT:PAGE:COMPANY_LABEL'], type: 'text', required: true, name: 'company'},
                    {label: translations['GLOBAL:PHONE_NUMBER'], type: 'text', required: true, name: 'phone_number'},
                    {label: translations['EVENT:PAGE:TITLE_LABEL'], type: 'text', required: true, name: 'title'},
                    {label: translations['EVENT:PAGE:CONSENT_LABEL'], type: 'checkbox', required: true, name: 'consent', values: [translations['GLOBAL:YES']]}
                ],
                content: {
                    heading: {index: 0, key: 'EVENT:PAGE:HEADING'},
                    subheading: {index: 1, key: 'EVENT:PAGE:SUBHEADING'},
                    time: {index: 2, key: 'EVENT:PAGE:TIME'},
                    place: {index: 3, key: 'EVENT:PAGE:PLACE'},
                    ingress: {index: 4, key: 'EVENT:PAGE:INGRESS'},
                    content: {index: 5, key: 'EVENT:PAGE:CONTENT'},
                    image: {index: 6, key: 'EVENT:PAGE:CONTENT_IMAGE'},
                    agenda: {index: 7, key: 'EVENT:PAGE:AGENDA'},
                    footer: {index: 8, key: 'EVENT:PAGE:FOOTER'},
                    time_changed_to: {index: 9, key: 'EVENT:PAGE:TIME'},
                    place_changed_to: {index: 10, key: 'EVENT:PAGE:PLACE'},
                },
                baseFieldNames: ['f_name', 'l_name', 'email', 'company', 'phone_number', 'title', 'consent']
            };

            this.episurvey = {
                forms: [
                    {label: translations['EVENT:PAGE:FIRST_NAME'], type: 'text', required: true, name: 'f_name'},
                    {label: translations['EVENT:PAGE:LAST_NAME'], type: 'text', required: true, name: 'l_name'},
                    {label: translations['GLOBAL:EMAIL'], type: 'email', required: true, name: 'email'},
                    {label: translations['EVENT:PAGE:SURVEY_SCORE'], type: 'radio', required: true, name: 'score', values: [1, 2, 3, 4, 5]},
                    {label: translations['EVENT:PAGE:COMMENTS'], type: 'textarea', required: false, name: 'comments'}
                ],
                content: {
                    heading: {text: 'EVENT:SURVEY:HEADER_CONTENT', key: 'EVENT:PAGE:HEADING'},
                    subheading: {text: 'EVENT:SURVEY:SUB_HEADER_CONTENT', key: 'EVENT:PAGE:SUBHEADING'},
                    content: {text: 'EVENT:SURVEY:MAIN_CONTENT', key: 'EVENT:PAGE:CONTENT'},
                    image: {text: null, key: 'EVENT:PAGE:CONTENT_IMAGE'}
                },
                baseFieldNames: ['f_name', 'l_name', 'email', 'score', 'comments']
            };

            this.fields = {
                1: { label: 'Text-input', type: 'text', required: false, name: 'textinput' },
                2: { label: 'Text-area', type: 'textarea', required: false, name: 'textarea' },
                3: { label: 'Radio-buttons', type: 'radio', required: false, name: 'radio', values: [1,2,3,4,5] },
                4: { label: 'Checkboxar', type: 'checkbox', required: false, name: 'checkboxes', values: [translations['GLOBAL:YES'], translations['GLOBAL:NO']] }
            };
        });

        this.eventRepo.find(this._stateParams.id).then((event) => {
            this.event = event.data;
            this.hasSavedPage() ? this.insertSavedPage() : this.insertOriginalContent();
            this.formatPageSchedule();
        });

        this._scope.$on('event:image:dragover', () => {
            this.dragActive = true;
        });

        this._scope.$on('event:image:dragleave', () => {
            this.dragActive = false;
        });

        this._scope.$on('event:image:drop', () => {
            this.dragActive = false;
            let imageContainer = $('.image-box');
            imageContainer.attr('contenteditable', true);

            try {
                CKEDITOR.inline(imageContainer[0], {customConfig: '/config/ckeditor_basic_image.js'});
            } catch (error) {
                let newImgSrc = $(imageContainer).find('img').attr('src');
                $(imageContainer).find('img').attr('data-cke-saved-src', newImgSrc);
            }

            this._timeout(() => {
                $('#image-placeholder').hide();
            }, 100);
        });

        this._scope.$on('event:page:save', (event, data) => {
            this.page.publish_at = data['publishAt'];
            this.save();
        });

        this._scope.$on('event:page:publish', (event, data) => {
            this.page.publish_at = data['publishAt'];
            this.save(false).then(() => {
                this.publishPage();
            });
        });

        this._scope.$on('account:changed', () => {
            this._state.go('event.index');
        });
    }

    onVisibilityChange() {
        if (! this.page.open) {
            this.previousVisibilityValue = this.page.visible;
            this.page.visible = false;
        } else {
            this.page.visible = this.previousVisibilityValue;
            this.restorBaseFormField();
        }
    }

    backToEvent() {
        let hasBeenSaved = this.event.pages[this._stateParams.type] != null;

        if (! hasBeenSaved) {
            this.alerter.swal({
                title: this._translator('EVENT:FLASH:BACK_HEADER'),
                text: this._translator('EVENT:FLASH:BACK_BODY'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: this._translator('GLOBAL:YES'),
                cancelButtonText: this._translator('GLOBAL:NO')
            }, (isConfirm) => {
                if (isConfirm) {
                    this.save().then(() => {
                        this._state.go('event.folder', { folder: this.statusIdToNameMap[this.event.event_status_id]});
                    });
                } else {
                    this._state.go('event.folder', { folder: this.statusIdToNameMap[this.event.event_status_id]});
                }
            });
        } else {
            this._state.go('event.folder', { folder: this.statusIdToNameMap[this.event.event_status_id]});
        }
    };

    formatPageSchedule() {
        if (this.event.pages[this._stateParams.type]) {
            this.page.publish_at = angular.fromJson(this.event.pages[this._stateParams.type].data).metadata.publish_at;
            this.publishDate = moment(this.page.publish_at).format('YYYY-MM-DD');
            this.publishTime = { hour: moment(this.page.publish_at).format('HH'), minutes: moment(this.page.publish_at).format('mm') };
        }
    };

    pageStatus() {
        if (this.event && this.event.pages[this._stateParams.type] && this.event.pages[this._stateParams.type].published) {
            if (! this.page.publish_at) {
                this.formatPageSchedule();
            }

            return moment(this.page.publish_at) > moment() ? 'scheduled' : 'published';
        } else {
            return 'non-scheduled';
        }
    };

    hasSavedPage() {
        return this.event.pages[this._stateParams.type] != null;
    };

    insertCKEditor() {
        this._timeout(() => {
            $('.page-section').each((index, item) => {
                CKEDITOR.inline(item, {customConfig: '/config/ckeditor_basic.js'});
            });

            if (this.constructor.hasImage()) {
                $('.image-box').attr('contenteditable', true);
                CKEDITOR.inline($('.image-box')[0], {customConfig: '/config/ckeditor_basic_image.js'});
            }
        });
    };

    insertInvitationContent() {
        this.eventRepo.getParsedInvitationContent(this.event.id).then((response) => {
            this.originalInvitationContent = response.data;
            angular.forEach(response.data, (content, key) => {
                this.texts[this[this._stateParams.type].content[key].index] = {
                    header: this[this._stateParams.type].content[key].key,
                    content: content, key: key,
                    disabled: this.readOnly.indexOf(key) !== -1
                };
            });

            this.texts[this[this._stateParams.type].content['image'].index] = { header: this[this._stateParams.type].content['image'].key, content: null, key: 'image' };
            this.insertCKEditor();
            this.loading = false;
        });
    };

    insertSurveyContent() {
        angular.forEach(this[this._stateParams.type].content, (content, key) => {
            this.texts.push({ header: content.key, content: this._translator(content.text), key: key });
        });

        this.insertCKEditor();
        this.loading = false;
    };

    insertOriginalContent() {
        this.texts = [];
        this.loading = true;
        this.forms = this[this.type].forms;

        if (this._stateParams.type == 'episubscription') {
            this.insertInvitationContent();
        } else if (this._stateParams.type == 'episurvey') {
            this.insertSurveyContent();
        }
    };

    static hasImage() {
        return $('#contentImage').attr('src').length > 0 && ! $('#contentImage').attr('src').startsWith('xxx');
    };

    toggleImageBank() {
        this.imageBankVisible = ! this.imageBankVisible;
        this._scope.$emit('imageBank:toggle');
    };

    onImageClick() {
        if (! this.constructor.hasImage()) {
            this.toggleImageBank();
        }
    }

    insertSavedPage() {
        let data = angular.fromJson(this.event.pages[this.type].data);
        this.texts = [];
        angular.forEach(data, (content, key) => {
            if (key == 'metadata') {
                angular.forEach(content, (value, key) => {
                    this.page[key] = value;
                });
            } else if (key == 'fields') {
                this.forms = this.statusIdToNameMap[this.event.event_status_id] == 'cancelled' ? null : content;
            } else if (key == 'content') {
                let html = $.parseHTML(content);
                let img;

                $(html).each((index, item) => {
                    if (($(item).is('a') && $(item).has('img').length) || $(item).is('img')) {
                        img = item;
                        var toMatch = $(item).is('a') ? '<a' : '<img';
                        content = content.substring(0, content.indexOf(toMatch));
                    }
                });

                this.texts.push({ header: this[this.type].content[key].key, content: content, key: key });
                this.texts.push({ header: this[this.type].content['image'].key, content: null, key: 'image' });

                if (img) {
                    this._timeout(() => {
                        $('#contentImage').replaceWith(img);
                        $('#image-placeholder').hide();
                    });
                }
            } else {
                if (key == 'form_text') {
                    $('#formText').find('textarea').first().val(content);
                } else {
                    if (['time', 'place'].indexOf(key) !== -1) {
                        this.texts.push({
                            header: this[this.type].content[key].key,
                            content: (data[key + '_changed_to'] && data[key + '_changed_to'] !== '<br>') ? data[key + '_changed_to'] : content,
                            key: key,
                            disabled: this.readOnly.indexOf(key) !== -1
                        });
                    } else {
                        this.texts.push({
                            header: this[this.type].content[key].key,
                            content: content,
                            key: key,
                            disabled: this.readOnly.indexOf(key) !== -1
                        });
                    }
                }
            }
        });

        this.insertCKEditor();
        this.loading = false;
    };

    removeOption(fieldIndex, optionIndex) {
        this.forms[fieldIndex].values.splice(optionIndex, 1);
    };

    addOption(fieldIndex) {
        this.forms[fieldIndex].values.push(this._translator('EVENT:PAGE:NEW_OPTION'));
    };

    parseContent() {
        this.data = {};
        var deferred = this._q.defer();
        var emptyField = '';

        $('.event-page-content').each((index, item) => {
            let key = $(item).children('.header').data('name');
            let content = $(item).children('.page-section').first().html();

            if (key == 'content' && this.constructor.hasImage()) {
                let img = $('#contentImage');
                let parent = img.parent();

                content += parent.is('a') ? parent.prop('outerHTML') : img.prop('outerHTML');
            }

            if (key != 'image') {
                if (content.length > 0) {
                    this.data[key] = content;
                } else {
                    emptyField = $(item).children('.header').text().trim();
                }
            }

            if (index == ($('.event-page-content').length - 1)) {
                emptyField.length == 0 ? deferred.resolve() : deferred.reject(emptyField);
            }
        });

        this.data['form_text'] = $('#formText').find('textarea').first().val();

        return deferred.promise;
    };

    save(publish = true) {
        this.isSaving = true;
        var deferred = this._q.defer();

        this.parseContent().then(() => {
            this.data.fields = this.forms;
            let consentIndex;

            angular.forEach(this.data.fields, (field, index) => {
                if (this[this.type].baseFieldNames.indexOf(field.name) == -1 || (! this.isBaseFormField(field) && this.type === 'episubscription')) { // Custom input field
                    field.name = this.slugService.slugify(field.label);
                }
                if (field.name === 'consent') {
                    consentIndex = index;
                }
            });

            if (consentIndex) {
                let consentField = this.data.fields.splice(consentIndex, 1);
                this.data.fields.push(consentField[0]);
            }

            if(this.type === 'episubscription') {
                let content = typeof this.event.pages[this.type] !== 'undefined' ? this.event.pages[this.type].data : this.originalInvitationContent;
                let data = angular.fromJson(content);
                this.data.place = data.place;
                this.data.time = data.time;
            }

            this.data.metadata = {
                open: this.page.open,
                publish_at: this.page.publish_at,
                visible: this.page.visible,
                closed: this.page.closed
            };

            this.eventRepo.savePage(this._stateParams.id, this.type, this.data).then((page) => {
                this.eventHandler.flashEvent('notification', this._translator('EVENT:PAGE:UPDATED'));
                let data = angular.fromJson(page.data);
                this.forms = data.fields;

                if (!this.event.pages[this.type]) {
                    this.event.pages[this.type] = {status: 0};
                } else if (publish && this.event.pages[this.type].published) {
                    this.publishPage();
                }

                deferred.resolve();
                this.isSaving = false;
            });
        }, (rejection) => {
            deferred.reject();
            this.isSaving = false;

            this.alerter.swal({
                title: this._translator('translate')('EVENT:PAGE:EMPTY_FIELD_HEADER'),
                text: this._translator('translate')('EVENT:PAGE:EMPTY_FIELD_BODY').replace(':name', rejection),
                type: 'error'
            });
        });

        return deferred.promise;
    };

    togglePublishScheduler() {
        this._scope.$broadcast('event:page:showScheduler', { event: this.event, page: this.page });
    };

    publishPage() {
        this.alerter.swal({
            title: this._translator('EVENT:FLASH:EVENT_PAGE_SENDING_HEADER'),
            text: this._translator('EVENT:FLASH:EVENT_PAGE_SENDING_BODY'),
            type: 'info'
        });

        this.eventRepo.publishPage(this._stateParams.id, this.type).then((response) => {
            if (response.code > 0) {
                $('.showSweetAlert, .sweet-overlay').fadeOut();
                $('body').removeClass('stop-scrolling');

                this.event.pages[this.type].status = response.code;
                this.event.pages[this.type].published = true;
                this.eventHandler.flashEvent('notification', this._translator('EVENT:FLASH:EVENT_PAGE_GENERATED'));

                this.eventRepo.find(this._stateParams.id).then((event) => {
                    this.event = event.data;
                    this.formatPageSchedule();
                });
            } else {
                this.alerter.swal({
                    title: this._translator('EVENT:FLASH:PUBLISH_FAILED_HEADER'),
                    text: this._translator('EVENT:FLASH:PUBLISH_FAILED_BODY'),
                    type: 'error'
                });
            }
        }, (error) => {

            if (error.status == 404) {
                this.alerter.swal({
                    title: this._translator('EVENT:FLASH:IMAGES_MISSING_HEADER'),
                    text: this._translator('EVENT:FLASH:IMAGES_MISSING_BODY'),
                    type: 'error'
                });
            } else if (error.status == 400) {
                this.alerter.swal({
                    title: this._translator('EVENT:FLASH:PUBLISH_FAILED_HEADER'),
                    text: this._translator('EVENT:FLASH:SETUP_INCOMPLETE'),
                    type: 'error'
                });
            } else {
                this.alerter.swal({
                    title: this._translator('EVENT:FLASH:PUBLISH_FAILED_HEADER'),
                    text: this._translator('EVENT:FLASH:PUBLISH_FAILED_BODY'),
                    type: 'error'
                });
            }
        });
    };

    previewPage() {
        this.save(false).then(() => {
            this.alerter.swal({
                title: this._translator('EVENT:FLASH:EVENT_PREVIEW_SENDING_HEADER'),
                text: this._translator('EVENT:FLASH:EVENT_PREVIEW_SENDING_BODY'),
                type: 'info'
            });

            this.eventRepo.previewPage(this._stateParams.id, this.type).then((response) => {
                if (response.code > 0) {
                    $('.showSweetAlert, .sweet-overlay').fadeOut();
                    $('body').removeClass('stop-scrolling');

                    this.event.pages[this.type].status = response.code;
                    this.eventHandler.flashEvent('notification', this._translator('EVENT:FLASH:EVENT_PAGE_GENERATED'));

                    this.eventRepo.find(this._stateParams.id).then((event) => {
                        this.event = event.data;
                        window.open(this.event.pages[this.type].visit_url, "_blank");
                    });
                } else {
                    this.alerter.swal({
                        title: this._translator('EVENT:FLASH:PUBLISH_FAILED_HEADER'),
                        text: this._translator('EVENT:FLASH:PUBLISH_FAILED_BODY'),
                        type: 'error'
                    });
                }
            }, (error) => {

                if (error.status == 404) {
                    this.alerter.swal({
                        title: this._translator('EVENT:FLASH:IMAGES_MISSING_HEADER'),
                        text: this._translator('EVENT:FLASH:IMAGES_MISSING_BODY'),
                        type: 'error'
                    });
                } else if (error.status == 400) {
                    this.alerter.swal({
                        title: this._translator('EVENT:FLASH:PUBLISH_FAILED_HEADER'),
                        text: this._translator('EVENT:FLASH:SETUP_INCOMPLETE'),
                        type: 'error'
                    });
                } else {
                    this.alerter.swal({
                        title: this._translator('EVENT:FLASH:PUBLISH_FAILED_HEADER'),
                        text: this._translator('EVENT:FLASH:PUBLISH_FAILED_BODY'),
                        type: 'error'
                    });
                }
            });
        });
    };

    removeImg() {
        angular.forEach(CKEDITOR.instances, (instance) => {
            if ($(instance.element)[0].hasClass('image-box')) {
                instance.destroy();
            }
        });

        let imageContainer = $('.image-box');
        imageContainer.find('img').attr('src', '');
        imageContainer.removeAttr('contenteditable');

        // Remove wrapping anchor
        if (imageContainer.find('a').length) {
            imageContainer.find('img').unwrap();
        }

        $('#image-placeholder').show();
    };

    removeField(fieldIndex) {
        this.forms.splice(fieldIndex, 1);
    };

    isBaseFormField(form) {
        if (this.page.open) {
            return form.name == 'email' || form.name == 'f_name' || form.name == 'l_name' ||
                form.name == 'company' || form.name == 'phone_number' || form.name == 'title' || form.name == 'consent';
        } else {
            return form.name == 'email' || form.name == 'consent';
        }
    };

    createField(fieldKey) {
        if (fieldKey) {
            this.forms.push(angular.copy(this.fields[fieldKey]));
        }
    };

    restorBaseFormField() {
        let baseFormFields = this.episubscription.forms;

        angular.forEach(this.forms, (field, index) => {
            if (index < baseFormFields.length) {
                field.name = baseFormFields[index].name;
            }
        });
    }

    fieldMove(direction, fieldIndex) {
        let toIndex;

        if (direction === "up") {
            toIndex = fieldIndex - 1;
        } else if (direction === "down") {
            toIndex = fieldIndex + 1;
        }
        if (toIndex < 0 || toIndex > this.forms.length) {
            return
        }

        this.forms.splice(toIndex, 0, this.forms.splice(fieldIndex, 1)[0]);
    }
};
